
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 4v14h-.313a2.971 2.971 0 00-2.968 2.688L18 26.875 17.875 28h10.25L28 26.875l-.813-6.188c-.152-1.539-1.464-2.687-3-2.687H24V4zM11 9a4.008 4.008 0 00-3.688 2.406l-1.5-2-1.625 1.188L6.75 14H3.812l2.376 14h9.625l2.374-14h-7.375l1.376 2h3.624l-1.624 10H7.811L6.188 16H8.25l1.938 2.594h.03A.976.976 0 0011 19c.55 0 1-.45 1-1a.971.971 0 00-.219-.594h.031l-.093-.125L8.5 13H9c0-1.191.809-2 2-2 1.191 0 2 .809 2 2h2c0-.215.285-.5.5-.5.215 0 .5.285.5.5h2c0-1.383-1.117-2.5-2.5-2.5a2.46 2.46 0 00-1.156.313A3.967 3.967 0 0011 9zm10.688 11h2.5c.464 0 .984.445 1.03.906V21h-4.53v-.094c.046-.46.535-.906 1-.906zm-1.22 3h5l.376 3h-5.719z"}})])
          )
        }
      }
    